import styles from "./styles.module.scss";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  ResponsiveContainer,
} from "recharts";
import { chartData } from "./mock";
import { useState } from "react";

export const ChartOverview = () => {
  const [view, setView] = useState("Week View");

  const handleViewChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    setView(e.target.value);
  };

  return (
    <div className={styles.chartWrapper}>
      <div className={styles.chartHeader}>
        <h2>Review Score</h2>
        <select
          className={styles.selectDropdown}
          value={view}
          onChange={handleViewChange}
        >
          <option value="Week View">Week View</option>
          <option value="Month View">Month View</option>
        </select>
      </div>
      <div style={{ width: "100%", height: "320px" }}>
        <ResponsiveContainer width="100%" height="100%">
          <LineChart data={chartData}>
            <CartesianGrid
              stroke="#333"
              strokeDasharray="0"
              horizontal
              vertical
            />
            <XAxis
              dataKey="name"
              tick={{ fill: "#666", fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              yAxisId="left"
              domain={[0, 5]}
              tick={{ fill: "#666", fontSize: 12 }}
              axisLine={false}
              tickLine={false}
            />
            <YAxis
              yAxisId="right"
              orientation="right"
              domain={[20, 60]}
              tick={{ fill: "#666", fontSize: 12 }}
              tickFormatter={(value) => `${value}%`}
              axisLine={false}
              tickLine={false}
            />
            <Line
              yAxisId="left"
              type="monotone"
              dataKey="reviewScore"
              stroke="#7F5AF0"
              strokeWidth={2}
              dot={false}
            />
            <Line
              yAxisId="right"
              type="monotone"
              dataKey="percentage"
              stroke="#7F5AF0"
              strokeWidth={0}
              dot={false}
            />
          </LineChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
};
